import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import CounterSection from '../../sections/CounterSection/CounterSection';
import MigrationSection from '../../sections/MigrationSection/MigrationSection';
import { GlobalStyle } from '../../global/global';
import StyledButton from '../../components/Button/Button';
import './styles.css';
import {
    Box,
    Flex,
    Text,
    Image,
    Link,
    SimpleGrid,
    List, 
    ListIcon, 
    ListItem
} from '@chakra-ui/react';
import FormSection from '../../sections/FormSection/FormSection';
import { AddIcon } from '@chakra-ui/icons';
import { Show, Hide } from '@chakra-ui/react'



interface Props {}

const heroImage = {
    url: 'https://www.idosell.com/panel/file-gate.php?id=592190&ext=.jpeg',
    alt: 'Prace kontraktowe',
};

export default function ContractsPage(props: Props) {
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <HeroSection
                title={<>Powierz swój sklep internetowy profesjonalistom</>}
                image={heroImage}
                subTitle="Sprawdź, jak możemy Ci pomóc rozwinąć sprzedaż."
                buttons={[
                    {
                        title: 'Skontaktuj się z ekspertem',
                        href: '#contracts_form',
                        variant: 'default',
                    },
                ]}
            />

            <Flex
                className="homepage containerIdosellPages contractsPage"
                direction={'column'}
                overflow-x={'hidden'}
                gap={{
                    base: 16,
                    md: 24,
                }}
                py={{
                    base: 0,
                    md: 8,
                }}
            >

                <Box className='contracts_form' id='contracts_form' scrollMarginTop={{ base: "55px", lg: "80px" }}>
                    <FormSection
                        sectionTitle="Rozwiń swój sklep internetowy z nami"
                        sectionSubtitle="Wypełnij formularz i wybierz usługi graficzne lub developerskie dopasowane do Twoich potrzeb."
                        region="eu1"
                        portalId="26134891"
                        formId="d1a8e3c5-60b0-423c-b2bd-8b403f9528aa"
                    />
                </Box>
                
                
                <CounterSection
                    className='counter_section'
                    title="Rozwiń potencjał swojego sklepu internetowego"
                    subtitle="Postaw na doświadczenie z gwarancją prowadzonych prac"
                    layout="1x4"
                    items={[
                        {
                            mainNumber: '13',
                            additionalText: '',
                            text: 'doświadczonych grafików i developerów do dyspozycji',
                        },
                        {
                            mainNumber: '5+',
                            additionalText: ' tys.',
                            text: 'przepracowanych dni kontraktowych',
                        },
                        {
                            mainNumber: '850+',
                            additionalText: '',
                            text: 'obsłużonych sklepów internetowych',
                        },
                        {
                            mainNumber: '25',
                            additionalText: ' lat',
                            text: 'doświadczenia w branży e-commerce',
                        },
                    ]}
                    data="string"
                />

                <Box>
                    <Text fontSize={{base: "30px", md: "34px"}} lineHeight={{base: "33px", md: "40px"}} marginBottom={{base: "10px", md: "5px"}} fontWeight="600" textAlign="center">Sprawdź, jak możemy wesprzeć rozwój Twojego sklepu</Text>
                    <Text fontSize={{base: "16px", md: "18px"}} fontWeight="400" textAlign="center">Oferujemy szeroki zakres prac graficznych i developerskich</Text>
                    <SimpleGrid pt="50px" columns={{base: 1, sm: 2, lg: 4}} spacing="30px" maxWidth={{base: "calc(100vw - 20px)", md: "100%"}} overflow="hidden">
                        <Box padding="30px 30px 20px 30px" bg="#EEEEEE">
                            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="start" marginBottom="24px">
                                <Text fontSize="21px" fontWeight="600" textAlign="left">Audyt UX/UI</Text>
                                <Box display={'block'} bg={'#000'} width={'30px'} height={'3px'} marginTop={'20px'} />
                            </Box>
                            <Text fontSize="16px" fontWeight="400" textAlign="left" marginBottom="10px">Analiza UX/UI  sklepu pozwoli zidentyfikować  obszary do zmiany i dostarczy wskazówki, które poprawią konwersję.</Text>
                        </Box>
                        <Box padding="30px 30px 20px 30px" bg="#EEEEEE">
                            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="start" marginBottom="24px">
                                <Text fontSize="21px" fontWeight="600" textAlign="left">Kreacje graficzne</Text>
                                <Box display={'block'} bg={'#000'} width={'30px'} height={'3px'} marginTop={'20px'} />
                            </Box>
                            <Text fontSize="16px" fontWeight="400" textAlign="left" marginBottom="10px">Odświeżenie wizerunku,  nowy projekt podstron czy banery reklamowe - tworzymy użyteczne i atrakcyjne kreacje.</Text>
                        </Box>
                        <Box padding="30px 30px 20px 30px" bg="#EEEEEE">
                            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="start" marginBottom="24px">
                                <Text fontSize="21px" fontWeight="600" textAlign="left">Prace developerskie</Text>
                                <Box display={'block'} bg={'#000'} width={'30px'} height={'3px'} marginTop={'20px'} />
                            </Box>
                            <Text fontSize="16px" fontWeight="400" textAlign="left" marginBottom="10px">Oferujemy kompleksowe i dostosowane do indywidualnych potrzeb prace developerskie.</Text>
                        </Box>
                        <Box padding="30px 30px 20px 30px" bg="#EEEEEE">
                            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="start" marginBottom="24px">
                                <Text fontSize="21px" fontWeight="600" textAlign="left">Aktualizacja szablonów</Text>
                                <Box display={'block'} bg={'#000'} width={'30px'} height={'3px'} marginTop={'20px'} />
                            </Box>
                            <Text fontSize="16px" fontWeight="400" textAlign="left" marginBottom="10px">Każdy sklep potrzebuje ulepszeń. W IdoSell regularnie wdrażamy zmiany i usprawnienia.</Text>
                        </Box>
                        <Box padding="30px 30px 20px 30px" bg="#EEEEEE">
                            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="start" marginBottom="24px">
                                <Text fontSize="21px" fontWeight="600" textAlign="left">Optymalizacja szybkości</Text>
                                <Box display={'block'} bg={'#000'} width={'30px'} height={'3px'} marginTop={'20px'} />
                            </Box>
                            <Text fontSize="16px" fontWeight="400" textAlign="left" marginBottom="10px">Każda dodatkowa sekunda ładowania sklepu zwiększa ryzyko odrzucenia strony o 10%.</Text>
                        </Box>
                        <Box padding="30px 30px 20px 30px" bg="#EEEEEE">
                            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="start" marginBottom="24px">
                                <Text fontSize="21px" fontWeight="600" textAlign="left">Testy A/B</Text>
                                <Box display={'block'} bg={'#000'} width={'30px'} height={'3px'} marginTop={'20px'} />
                            </Box>
                            <Text fontSize="16px" fontWeight="400" textAlign="left" marginBottom="10px">Regularne testy A/B pomagają dopasować sklep do oczekiwań klientów, co zwiększa skuteczność i konwersję.</Text>
                        </Box>
                        <Box padding="30px 30px 20px 30px" bg="#EEEEEE">
                            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="start" marginBottom="24px">
                                <Text fontSize="21px" fontWeight="600" textAlign="left">Konfiguratory</Text>
                                <Box display={'block'} bg={'#000'} width={'30px'} height={'3px'} marginTop={'20px'} />
                            </Box>
                            <Text fontSize="16px" fontWeight="400" textAlign="left" marginBottom="10px">Stworzymy konfiguratory, które ułatwią klientom personalizację produktów i zwiększą ich zaangażowanie.</Text>
                        </Box>
                        <Box padding="30px 30px 20px 30px" bg="#EEEEEE">
                            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="start" marginBottom="24px">
                                <Text fontSize="21px" fontWeight="600" textAlign="left">Logo</Text>
                                <Box display={'block'} bg={'#000'} width={'30px'} height={'3px'} marginTop={'20px'} />
                            </Box>
                            <Text fontSize="16px" fontWeight="400" textAlign="left" marginBottom="10px">Potrzebujesz nowego logo lub identyfikacji wizualnej? Stworzymy wszystko, by Twoja marka się wyróżniała!</Text>
                        </Box>
                    </SimpleGrid> 
                </Box>

                {/* NEW SECTION */}

                <Show breakpoint='(min-width: 979px)'>
                    <Box display={'grid'} gridTemplateColumns={'1fr 1fr'} gap={'30px'} marginTop={'60px'}>
                        <Box>
                            <Image
                                src="https://www.idosell.com/panel/file-gate.php?id=605977&ext=.webp"
                                alt="Zdjęcie sekcji z tickami"
                                objectFit={'cover'}
                                width={'100%'}
                                height={'100%'}
                            />
                        </Box>
                        <Box p={'40px'}>
                            <Text
                                fontSize={'34px'}
                                lineHeight={'1.5'}
                                fontWeight={'600'}
                                color={'#1AAC7A'}
                                mb="30px"
                            >
                                Audyt sklepu internetowego to szansa na rozwój Twojego biznesu
                            </Text>
                            <List
                                spacing={'30px'}
                                fontSize={'18px'}
                                lineHeight={'27px'}
                                color={'#171717'}
                            >
                                <ListItem display={'flex'}>
                                    <ListIcon
                                        as={AddIcon}
                                        color="green.500"
                                        mr={'30px'}
                                        mt={'5px'}
                                    />
                                    <Box>
                                        <Text
                                            color={''}
                                            fontSize={'21px'}
                                            lineHeight={'1.5'}
                                            fontWeight={'600'}
                                            mb="5px"
                                        >
                                            Wyeliminuj błędy
                                        </Text>
                                        <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                            Odkryj, co spowalnia rozwój Twój sklep – my znajdziemy słabe punkty i pokażemy Ci, jak zamienić je w przewagi.
                                        </Text>
                                    </Box>
                                </ListItem>
                                <ListItem display={'flex'}>
                                    <ListIcon
                                        as={AddIcon}
                                        color="green.500"
                                        mr={'30px'}
                                        mt={'5px'}
                                    />
                                    <Box>
                                        <Text
                                            fontSize={'21px'}
                                            lineHeight={'1.5'}
                                            fontWeight={'600'}
                                            mb="5px"
                                        >
                                            Zwiększ widoczność i rozpoznawalność
                                        </Text>
                                        <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                            Z naszymi rozwiązaniami przyciągniesz więcej klientów i sprawisz, że chętniej zostaną na Twojej stronie!
                                        </Text>
                                    </Box>
                                </ListItem>
                                <ListItem display={'flex'}>
                                    <ListIcon
                                        as={AddIcon}
                                        color="green.500"
                                        mr={'30px'}
                                        mt={'5px'}
                                    />
                                    <Box>
                                        <Text
                                            fontSize={'21px'}
                                            lineHeight={'1.5'}
                                            fontWeight={'600'}
                                            mb="5px"
                                        >
                                            Popraw konwersję i sprzedaż
                                        </Text>
                                        <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                            Wdrożenie zaleceń naszych ekspertów pomoże Ci przyciągnąć więcej klientów i skuteczniej zachęcić ich do zakupów.
                                        </Text>
                                    </Box>
                                </ListItem>
                            </List>
                            <Box display={'flex'} justifyContent={'center'} marginTop={'45px'}>
                                <StyledButton
                                    href="https://www.idosell.com/pl/audyt-sklepu-internetowego/"
                                    style="default"
                                    target="_blank"
                                >
                                    Dowiedz się więcej
                                </StyledButton>
                            </Box>
                        </Box>
                    </Box>
                </Show>

                <Show breakpoint='(max-width: 978px)'>
                    <Box display={'grid'} gridTemplateColumns={'1fr'} gap={'30px'}>
                        <Text
                                fontSize={'30px'}
                                lineHeight={'37ox'}
                                fontWeight={'600'}
                                color={'#1AAC7A'}
                                mb="5px"
                                textAlign={'center'}
                            >
                                Audyt sklepu internetowego to szansa na rozwój Twojego biznesu
                        </Text>
                        <Box>
                            <Image
                                src="https://www.idosell.com/panel/file-gate.php?id=605978&ext=.webp"
                                alt="Zdjęcie sekcji z tickami"
                                objectFit={'cover'}
                                width={'100%'}
                                height={'100%'}
                            />
                        </Box>
                        <Box p={'0px 15px'}>
                            
                            <List
                                spacing={'30px'}
                                fontSize={'18px'}
                                lineHeight={'27px'}
                                color={'#171717'}
                            >
                                <ListItem display={'flex'}>
                                    <ListIcon
                                        as={AddIcon}
                                        color="green.500"
                                        mr={'30px'}
                                        mt={'5px'}
                                    />
                                    <Box>
                                        <Text
                                            color={''}
                                            fontSize={'21px'}
                                            lineHeight={'1.5'}
                                            fontWeight={'600'}
                                            mb="5px"
                                        >
                                            Wyeliminuj błędy
                                        </Text>
                                        <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                            Odkryj, co spowalnia rozwój Twój sklep – my znajdziemy słabe punkty i pokażemy Ci, jak zamienić je w przewagi.
                                        </Text>
                                    </Box>
                                </ListItem>
                                <ListItem display={'flex'}>
                                    <ListIcon
                                        as={AddIcon}
                                        color="green.500"
                                        mr={'30px'}
                                        mt={'5px'}
                                    />
                                    <Box>
                                        <Text
                                            fontSize={'21px'}
                                            lineHeight={'1.5'}
                                            fontWeight={'600'}
                                            mb="5px"
                                        >
                                            Zwiększ widoczność i rozpoznawalność
                                        </Text>
                                        <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                            Z naszymi rozwiązaniami przyciągniesz więcej klientów i sprawisz, że chętniej zostaną na Twojej stronie!
                                        </Text>
                                    </Box>
                                </ListItem>
                                <ListItem display={'flex'}>
                                    <ListIcon
                                        as={AddIcon}
                                        color="green.500"
                                        mr={'30px'}
                                        mt={'5px'}
                                    />
                                    <Box>
                                        <Text
                                            fontSize={'21px'}
                                            lineHeight={'1.5'}
                                            fontWeight={'600'}
                                            mb="5px"
                                        >
                                            Popraw konwersję i sprzedaż
                                        </Text>
                                        <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                            Wdrożenie zaleceń naszych ekspertów pomoże Ci przyciągnąć więcej klientów i skuteczniej zachęcić ich do zakupów.
                                        </Text>
                                    </Box>
                                </ListItem>
                            </List>
                            <Box display={'flex'} justifyContent={'center'} marginTop={'30px'}>
                                <Box width="auto">
                                    <StyledButton
                                        href="https://www.idosell.com/pl/audyt-sklepu-internetowego/"
                                        style="default"
                                        target="_blank"
                                    >
                                        Dowiedz się więcej
                                    </StyledButton>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Show>

                

                {/* end NEW SECTION */}

                <MigrationSection
                    className='cta_section'
                    image={{
                        url: 'https://www.idosell.com/panel/file-gate.php?id=592222&ext=.jpeg',
                    }}
                    boxSide="left"
                    title="Rozwijaj swój sklep z pracami kontraktowymi"
                    subtitle=""
                    ctaButton={{
                        title: 'Skontaktuj się z nami',
                        href: '#contracts_form',
                        variant: 'default',
                        target: '_self'
                    }}
                >
                    <>
                        <Text mb="30px">
                            IdoSell posiada zespół doświadczonych grafików i webdeveloperów, którzy specjalizują się w e-commerce. Dzięki ich wiedzy i umiejętnościom Twój sklep może stać się się bardziej atrakcyjny i skuteczny.
                        </Text>
                        <Text mb="30px">
                            Wdrożenie to dopiero początek – w każdej chwili możesz zlecić nam redesign lub rozbudowę sklepu, bez konieczności poszukiwania zewnętrznych specjalistów. 
                        </Text>
                    </>
                </MigrationSection>
                
                <Box className="logo_section" maxWidth={{base: "100vw", md: "100%"}}>
                    <Text fontSize={{base: "30px", md: "34px"}} lineHeight={{base: "33px", md: "40px"}} marginBottom={{base: "40px", md: "50px"}} fontWeight="600" textAlign="center">Zaufali nam</Text>
                    <SimpleGrid className="logo_section__logos" columns={{sm: 2, lg: 5}} spacingX="20px" spacingY='10px' paddingLeft={{base: "15px", md: "15px"}} paddingRight={{base: "15px", md: "0"}} display={"grid"}>
                        <Link href="https://www.denley.pl/" target='_blank' minWidth={{base: "200px", md: "auto"}} padding="12px 20px" border="1px solid #E7E7E7" height="100px" display="flex" justifyContent="center" alignItems="center" _hover={{ borderColor: "#1AAC7A" }}>
                            <Image src="https://www.idosell.com/panel/file-gate.php?id=479222&ext=.svg" height="auto" maxHeight={'100%'} />
                        </Link>
                        <Link href="https://www.dolina-noteci.pl/" target='_blank'  minWidth={{base: "200px", md: "auto"}} overflow="hidden" padding="12px 20px" border="1px solid #E7E7E7" height="100px" display="flex" justifyContent="center" alignItems="center" _hover={{ borderColor: "#1AAC7A" }}>
                            <Image src="https://www.idosell.com/panel/file-gate.php?id=479223&ext=.svg" height="auto" maxHeight={'100%'} />
                        </Link>
                        <Link href="https://www.edomator.pl/" target='_blank' minWidth={{base: "200px", md: "auto"}} padding="12px 20px" border="1px solid #E7E7E7" height="100px" display="flex" justifyContent="center" alignItems="center" _hover={{ borderColor: "#1AAC7A" }}>
                            <Image src="https://www.idosell.com/panel/file-gate.php?id=479224&ext=.svg" height="auto" maxHeight={'100%'} />
                        </Link>
                        <Link href="https://www.esus-it.pl/" target='_blank' minWidth={{base: "200px", md: "auto"}} padding="12px 20px" border="1px solid #E7E7E7" height="100px" display="flex" justifyContent="center" alignItems="center" _hover={{ borderColor: "#1AAC7A" }}>
                            <Image src="https://www.idosell.com/panel/file-gate.php?id=479226&ext=.svg" height="auto" maxHeight={'100%'} />
                        </Link>
                        <Link href="https://www.kontri.pl/" target='_blank' minWidth={{base: "200px", md: "auto"}} padding="12px 20px" border="1px solid #E7E7E7" height="100px" display="flex" justifyContent="center" alignItems="center" _hover={{ borderColor: "#1AAC7A" }}>
                            <Image src="https://www.idosell.com/panel/file-gate.php?id=479227&ext=.svg" height="auto" maxHeight={'100%'} />
                        </Link>
                        <Link href="https://adrenaline.pl/" target='_blank' minWidth={{base: "200px", md: "auto"}} padding="12px 20px" border="1px solid #E7E7E7" height="100px" display="flex" justifyContent="center" alignItems="center" _hover={{ borderColor: "#1AAC7A" }}>
                            <Image src="https://www.idosell.com/panel/file-gate.php?id=479228&ext=.svg" height="auto" maxHeight={'100%'} />
                        </Link>
                        <Link href="https://bromarkt.pl/" target='_blank' minWidth={{base: "200px", md: "auto"}} padding="12px 20px" border="1px solid #E7E7E7" height="100px" display="flex" justifyContent="center" alignItems="center" _hover={{ borderColor: "#1AAC7A" }}>
                            <Image src="https://www.idosell.com/panel/file-gate.php?id=479229&ext=.svg" height="auto" maxHeight={'100%'} />
                        </Link>
                        <Link href="https://mlamp.pl/" target='_blank' minWidth={{base: "200px", md: "auto"}} padding="12px 20px" border="1px solid #E7E7E7" height="100px" display="flex" justifyContent="center" alignItems="center" _hover={{ borderColor: "#1AAC7A" }}>
                            <Image src="https://www.idosell.com/panel/file-gate.php?id=479230&ext=.svg" height="auto" maxHeight={'100%'} />
                        </Link>
                        <Link href="https://quantumpmu.com/" target='_blank' minWidth={{base: "200px", md: "auto"}} padding="12px 20px" border="1px solid #E7E7E7" height="100px" display="flex" justifyContent="center" alignItems="center" _hover={{ borderColor: "#1AAC7A" }}>
                            <Image src="https://www.idosell.com/panel/file-gate.php?id=479231&ext=.svg" height="auto" maxHeight={'100%'} />
                        </Link>
                        <Link href="https://www.mito-pharma.pl/" target='_blank' minWidth={{base: "200px", md: "auto"}} padding="12px 20px" border="1px solid #E7E7E7" height="100px" display="flex" justifyContent="center" alignItems="center" _hover={{ borderColor: "#1AAC7A" }}>
                            <Image src="https://www.idosell.com/panel/file-gate.php?id=479232&ext=.svg" height="auto" maxHeight={'100%'} />
                        </Link>
                    </SimpleGrid>
                </Box>

                <Box paddingBottom={'40px'}>
                    <Text fontSize={{base: "30px", md: "34px"}} lineHeight={{base: "33px", md: "40px"}} marginBottom={{base: "10px", md: "15px"}} fontWeight="600" textAlign="center">Poznaj opinie naszych sprzedawców</Text>
                    <Text fontSize={{base: "16px", md: "18px"}} fontWeight="400" textAlign="center" marginBottom={'30px'}>Zobacz, jak klienci oceniają współpracę z nami</Text>
                    <Box display={'flex'} justifyContent={'center'}>
                        <StyledButton
                            href="https://www.idosell.com/pl/galeria-designow/"
                            style="outline"
                            target="_blank"
                        >
                            Zobacz nasze realizacje
                        </StyledButton>
                    </Box>

                    <SimpleGrid pt={'50px'} columns={{base: 1, md: 3}} spacing={'30px'} maxWidth={{base: "calc(100vw - 40px) !important", md: "100%"}} overflow={'hidden'}>
                        <Box>
                            <Text fontSize={'16px'} fontStyle={'italic'} fontWeight={'500'}>"Przy okazji dwa słowa o współpracy z Panem Konradem. Współpraca z Panem, w każdym razie ten etap, była wyjątkowo profesjonalna i rzeczowa. Najważniejsze, że zgodnie z harmonogramem, klarownie i efektywnie. Ważne dla mnie było przede wszystkim zrozumienie naszych potrzeb i propozycje dla ich realizacji w zgodzie z trendami. Jakość otrzymanych materiałów na najwyższym poziomie, a każda poprawka, drobne korekty były wprowadzane szybko i zgodnie z naszymi wytycznymi. (...) ta współpraca była przykładem perfekcyjnej koordynacji i zaangażowania, co przełożyło się na to, że wymazuje z pamięci te mniej przyjemne doświadczenia z zespołem IAI. Dora robota, dziękuję Panie Konradzie."</Text>
                            <Text fontSize={'15px'} fontWeight={'700'} marginTop={'15px'} display={'flex'}>Tomasz Ł. <Image src="https://www.idosell.com/panel/file-gate.php?id=592429&ext=.svg" height="auto" marginLeft={'10px'} /></Text>
                            <Link href="https://www.zanature.com/" target='_blank' textDecoration={'underline'} fontSize={'15px'}>www.zanature.com</Link>
                        </Box>
                        <Box>
                            <Text fontSize={'16px'} fontStyle={'italic'} fontWeight={'500'}>"Z Panem Szymonem pracowaliśmy w ramach prac kontraktowych 3 lata i śmiało mogę powiedzieć, że była to najbardziej efektywna i profesjonalna współpraca deweloperska w moim doświadczeniu. Prace kontraktowe wynosiły, w zależności od potrzeb, 1 lub 2 dni w tygodniu i obejmowały stosunkowo szeroki zakres, ponieważ były to zarówno zmiany koderskie i wsparcie supportowe, jak i integracje z zewnętrznymi rozwiązaniami, indywidualne funkcjonalności, tworzenie feedów/sterowników czy komunikacja z firmami zewnętrznymi. Pan Szymon nie tylko realizował zlecone zadania, ale w razie potrzeby doradzał, rekomendował i proponował alternatywy (szczególnie cenne!) (...)"</Text>
                            <Text fontSize={'16px'} fontStyle={'italic'} fontWeight={'500'}>Stale korzystamy ze stworzonych przez Pana Szymona rozwiązań w zakresie prezentacji treści na stronie sklepu, w tym np. mechanizm oznaczania produktów na zdjęciach aranżacyjnych.</Text>
                            <Text fontSize={'16px'} fontStyle={'italic'} fontWeight={'500'}>W nagłych sytuacjach, wymagających pilnej interwencji deweloper niezwłocznie analizował problem i wprowadzał poprawki. Zwłaszcza z tej perspektywy wsparcie dewelopera znającego sklep „od podszewki” jest nieocenione, a same prace przebiegają znacznie sprawniej."</Text>
                            <Text fontSize={'15px'} fontWeight={'700'} marginTop={'15px'} display={'flex'}>Katarzyna W. <Image src="https://www.idosell.com/panel/file-gate.php?id=592429&ext=.svg" height="auto" marginLeft={'10px'} /></Text>
                            <Link href="https://www.9design.pl/" target='_blank' textDecoration={'underline'} fontSize={'15px'}>9design.pl</Link>
                        </Box>
                        <Box>
                            <Text fontSize={'16px'} fontStyle={'italic'} fontWeight={'500'}>"Przez długie lata przechodziliśmy z IAI przez różne formy współpracy, począwszy od prac zlecanych w komunikatach i realizowanych na bieżąco, a kończąc na pracach kontraktowych z wyznaczonym terminem realizacji. Każda z tych form ma oczywiście swoje minusy i plusy jednakże dla właściciela lub osoby zarządzającej sklepem i nieco większym zespołem ludzi, prace kontraktowe to znacznie lepsze rozwiązanie. Wiadomo z góry, że w określonym dniu miesiąca dostajemy do dyspozycji "swojego" człowieka, który prowadzi cały czas nasz sklep i wie co w trawie piszczy. Zespół sklepu musi się przygotować do takiego dnia, zebrać pomysły, ustalić priorytety wdrożeniowe, przemyśleć i opisać zlecenie. (...)."</Text>
                            <Text fontSize={'15px'} fontWeight={'700'} marginTop={'15px'} display={'flex'}>Mariusz K. <Image src="https://www.idosell.com/panel/file-gate.php?id=592429&ext=.svg" height="auto" marginLeft={'10px'} /></Text>
                            <Link href="https://www.sadowniczy.pl/" target='_blank' textDecoration={'underline'} fontSize={'15px'}>www.sadowniczy.pl</Link>
                        </Box>
                    </SimpleGrid>
                </Box>
            </Flex>
        </ThemeProvider>
    );
}